import React, { useState, useEffect } from 'react';
import { api } from '../context/AuthContext';
import {
  Title,
  Card,
  Table,
  Button,
  Group,
  Text,
  Badge,
  Modal,
  TextInput,
  NumberInput,
  Select,
  Textarea,
  Grid,
  Stack,
  Loader,
  Center,
  ActionIcon,
  Tooltip,
  Checkbox,
  Paper,
  FileButton
} from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { notifications } from '@mantine/notifications';
import {
  IconPlus,
  IconPencil,
  IconTrash,
  IconCar,
  IconCheck,
  IconEye,
  IconEyeOff,
  IconUpload,
  IconDownload,
  IconFile,
  IconX,
  IconMail,
  IconCopy
} from '@tabler/icons-react';
import 'dayjs/locale/it';

function PraticheAuto() {
  const [pratiche, setPratiche] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingPratica, setEditingPratica] = useState(null);
  const [filtroStato, setFiltroStato] = useState('');
  const [mostraChiuse, setMostraChiuse] = useState(false);
  const [form, setForm] = useState({
    cliente_nome: '', cliente_telefono: '', cliente_email: '',
    cliente_codice_fiscale: '', cliente_indirizzo: '',
    fornitore_nome: 'Galdieri',
    marca: '', modello: '', targa: '', telaio: '',
    finanziaria: 'Compass', importo_finanziamento: 0, importo_acconto: 0,
    commissione_compass: 0,
    costo_pratica_passaggio: 0,
    costo_acquisto_veicolo: 0, data_scadenza_pagamento: null,
    spese_aci: 0,
    costi_manutenzione: 0, note_manutenzione: '',
    stato: 'richiesta', note: '',
    finanziamento_incassato: false, acconto_incassato: false,
    commissione_incassata: false,
    incassato_pratica_passaggio: false, pagato_fornitore: false, pagate_aci: false
  });

  useEffect(() => { loadPratiche(); }, [filtroStato]);

  const loadPratiche = async () => {
    try {
      const params = filtroStato ? { stato: filtroStato } : {};
      const res = await api.get('/pratiche-auto', { params });
      setPratiche(res.data);
    } catch (err) {
      notifications.show({ title: 'Errore', message: 'Impossibile caricare le pratiche', color: 'red' });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        ...form,
        importo_finanziamento: form.importo_finanziamento || 0,
        importo_acconto: form.importo_acconto || 0,
        commissione_compass: form.commissione_compass || 0,
        costo_pratica_passaggio: form.costo_pratica_passaggio || 0,
        costo_acquisto_veicolo: form.costo_acquisto_veicolo || 0,
        spese_aci: form.spese_aci || 0,
        costi_manutenzione: form.costi_manutenzione || 0,
        data_scadenza_pagamento: form.data_scadenza_pagamento ? `${form.data_scadenza_pagamento.getFullYear()}-${String(form.data_scadenza_pagamento.getMonth()+1).padStart(2,'0')}-${String(form.data_scadenza_pagamento.getDate()).padStart(2,'0')}` : null
      };
      if (editingPratica) {
        await api.put(`/pratiche-auto/${editingPratica.id}`, data);
        notifications.show({ title: 'Successo', message: 'Pratica aggiornata', color: 'green' });
      } else {
        await api.post('/pratiche-auto', data);
        notifications.show({ title: 'Successo', message: 'Pratica creata', color: 'green' });
      }
      setShowModal(false);
      resetForm();
      loadPratiche();
    } catch (err) {
      notifications.show({ title: 'Errore', message: 'Errore nel salvataggio', color: 'red' });
    }
  };

  const handleDuplicate = (pratica) => {
    setEditingPratica(null);
    setForm({
      cliente_nome: pratica.cliente_nome || '',
      cliente_telefono: pratica.cliente_telefono || '',
      cliente_email: pratica.cliente_email || '',
      cliente_codice_fiscale: pratica.cliente_codice_fiscale || '',
      cliente_indirizzo: pratica.cliente_indirizzo || '',
      fornitore_nome: pratica.fornitore_nome || 'Galdieri',
      marca: pratica.marca || '',
      modello: pratica.modello || '',
      targa: '',
      telaio: '',
      finanziaria: pratica.finanziaria || 'Compass',
      importo_finanziamento: pratica.importo_finanziamento || 0,
      importo_acconto: pratica.importo_acconto || 0,
      commissione_compass: pratica.commissione_compass || 0,
      costo_pratica_passaggio: pratica.costo_pratica_passaggio || 0,
      costo_acquisto_veicolo: pratica.costo_acquisto_veicolo || 0,
      data_scadenza_pagamento: null,
      spese_aci: pratica.spese_aci || 0,
      costi_manutenzione: pratica.costi_manutenzione || 0,
      note_manutenzione: pratica.note_manutenzione || '',
      stato: 'richiesta',
      note: pratica.note || '',
      finanziamento_incassato: false,
      acconto_incassato: false,
      commissione_incassata: false,
      incassato_pratica_passaggio: false,
      pagato_fornitore: false,
      pagate_aci: false,
    });
    setShowModal(true);
  };

  const handleEdit = (pratica) => {
    setEditingPratica(pratica);
    setForm({
      cliente_nome: pratica.cliente_nome || '',
      cliente_telefono: pratica.cliente_telefono || '',
      cliente_email: pratica.cliente_email || '',
      cliente_codice_fiscale: pratica.cliente_codice_fiscale || '',
      cliente_indirizzo: pratica.cliente_indirizzo || '',
      fornitore_nome: pratica.fornitore_nome || 'Galdieri',
      marca: pratica.marca || '',
      modello: pratica.modello || '',
      targa: pratica.targa || '',
      telaio: pratica.telaio || '',
      finanziaria: pratica.finanziaria || 'Compass',
      importo_finanziamento: pratica.importo_finanziamento || 0,
      importo_acconto: pratica.importo_acconto || 0,
      commissione_compass: pratica.commissione_compass || 0,
      costo_pratica_passaggio: pratica.costo_pratica_passaggio || 0,
      costo_acquisto_veicolo: pratica.costo_acquisto_veicolo || 0,
      data_scadenza_pagamento: pratica.data_scadenza_pagamento ? new Date(pratica.data_scadenza_pagamento) : null,
      spese_aci: pratica.spese_aci || 0,
      costi_manutenzione: pratica.costi_manutenzione || 0,
      note_manutenzione: pratica.note_manutenzione || '',
      note: pratica.note || '',
      stato: pratica.stato || 'richiesta',
      finanziamento_incassato: pratica.finanziamento_incassato || false,
      acconto_incassato: pratica.acconto_incassato || false,
      commissione_incassata: pratica.commissione_incassata || false,
      incassato_pratica_passaggio: pratica.incassato_pratica_passaggio || false,
      pagato_fornitore: pratica.pagato_fornitore || false,
      pagate_aci: pratica.pagate_aci || false
    });
    setShowModal(true);
  };

  const handleDelete = async (pratica) => {
    if (window.confirm(`Eliminare la pratica di ${pratica.cliente_nome}?`)) {
      try {
        await api.delete(`/pratiche-auto/${pratica.id}`);
        notifications.show({ title: 'Successo', message: 'Pratica eliminata', color: 'green' });
        loadPratiche();
      } catch (err) {
        notifications.show({ title: 'Errore', message: 'Errore nell\'eliminazione', color: 'red' });
      }
    }
  };

  const handleToggle = async (pratica, field, dateField) => {
    const newValue = !pratica[field];
    const updates = { 
      [field]: newValue,
      [dateField]: newValue ? (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; })() : null
    };
    try {
      await api.put(`/pratiche-auto/${pratica.id}`, updates);
      loadPratiche();
    } catch (err) {
      notifications.show({ title: 'Errore', message: 'Errore nell\'aggiornamento', color: 'red' });
    }
  };

  const resetForm = () => {
    setEditingPratica(null);
    setForm({
      cliente_nome: '', cliente_telefono: '', cliente_email: '',
      cliente_codice_fiscale: '', cliente_indirizzo: '',
      fornitore_nome: 'Galdieri',
      marca: '', modello: '', targa: '', telaio: '',
      finanziaria: 'Compass', importo_finanziamento: 0, importo_acconto: 0,
      commissione_compass: 0,
      costo_pratica_passaggio: 0,
      costo_acquisto_veicolo: 0, data_scadenza_pagamento: null,
      spese_aci: 0,
      costi_manutenzione: 0, note_manutenzione: '',
      stato: 'richiesta', note: '',
      finanziamento_incassato: false, acconto_incassato: false,
      commissione_incassata: false,
      incassato_pratica_passaggio: false, pagato_fornitore: false, pagate_aci: false
    });
  };

  const formatCurrency = (v) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v || 0);

  const statoFlow = ['richiesta', 'approvata', 'incassata', 'saldata', 'chiusa'];
  const statoColors = {
    richiesta: 'gray', approvata: 'blue', incassata: 'yellow',
    saldata: 'green', chiusa: 'teal', annullata: 'red'
  };

  const handleAdvanceStato = async (pratica) => {
    const currentIndex = statoFlow.indexOf(pratica.stato);
    if (pratica.stato === 'annullata' || currentIndex < 0 || currentIndex >= statoFlow.length - 1) return;
    const nextStato = statoFlow[currentIndex + 1];
    try {
      await api.put(`/pratiche-auto/${pratica.id}`, { stato: nextStato });
      notifications.show({ title: 'Successo', message: `Stato aggiornato a ${nextStato.toUpperCase()}`, color: 'green' });
      loadPratiche();
    } catch (err) {
      notifications.show({ title: 'Errore', message: 'Errore nell\'aggiornamento dello stato', color: 'red' });
    }
  };

  const getStatoBadge = (stato, pratica) => {
    const isClickable = stato !== 'annullata' && stato !== 'chiusa';
    const currentIndex = statoFlow.indexOf(stato);
    const nextStato = currentIndex >= 0 && currentIndex < statoFlow.length - 1 ? statoFlow[currentIndex + 1] : null;
    return (
      <Tooltip label={nextStato ? `Avanza a ${nextStato.toUpperCase()}` : 'Stato finale'} disabled={!isClickable}>
        <Badge
          color={statoColors[stato] || 'gray'}
          variant="light"
          style={{ cursor: isClickable ? 'pointer' : 'default' }}
          onClick={isClickable ? () => handleAdvanceStato(pratica) : undefined}
        >
          {stato?.toUpperCase()}
        </Badge>
      </Tooltip>
    );
  };

  const praticheFiltrate = !mostraChiuse && !filtroStato
    ? pratiche.filter(p => p.stato !== 'chiusa')
    : pratiche;

  if (loading) {
    return <Center h={400}><Loader size="lg" color="teal" /></Center>;
  }

  return (
    <Stack gap="lg">
      <Group justify="space-between">
        <Group>
          <IconCar size={28} color="rgb(32, 83, 87)" />
          <Title order={2}>Pratiche Auto</Title>
        </Group>
        <Group>
          <Select
            placeholder="Tutti gli stati"
            clearable
            value={filtroStato}
            onChange={setFiltroStato}
            data={[
              { value: 'richiesta', label: 'Richiesta' },
              { value: 'approvata', label: 'Approvata' },
              { value: 'incassata', label: 'Incassata' },
              { value: 'saldata', label: 'Saldata' },
              { value: 'chiusa', label: 'Chiusa' },
              { value: 'annullata', label: 'Annullata' },
            ]}
            style={{ width: 180 }}
          />
          <Button
            variant={mostraChiuse ? 'filled' : 'light'}
            color="gray"
            leftSection={mostraChiuse ? <IconEyeOff size={18} /> : <IconEye size={18} />}
            onClick={() => setMostraChiuse(!mostraChiuse)}
          >
            {mostraChiuse ? 'Nascondi chiuse' : 'Mostra chiuse'}
          </Button>
          <Button leftSection={<IconPlus size={18} />} onClick={() => { resetForm(); setShowModal(true); }}>
            Nuova Pratica
          </Button>
        </Group>
      </Group>

      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Table.ScrollContainer minWidth={1200}>
          <Table striped highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Cliente / Veicolo</Table.Th>
                <Table.Th>Fornitore</Table.Th>
                <Table.Th>Prezzo Veicolo</Table.Th>
                <Table.Th>Commissione</Table.Th>
                <Table.Th>Pratica Passaggio</Table.Th>
                <Table.Th>Costo Acquisto</Table.Th>
                <Table.Th>Spese ACI</Table.Th>
                <Table.Th>Margine</Table.Th>
                <Table.Th>Stato</Table.Th>
                <Table.Th>Azioni</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {praticheFiltrate.map(p => (
                <Table.Tr key={p.id}>
                  <Table.Td>
                    <Text fw={600}>{p.cliente_nome}</Text>
                    <Text size="sm" c="dimmed">{p.marca} {p.modello}</Text>
                    {p.targa && <Text size="xs" c="dimmed">Targa: {p.targa}</Text>}
                  </Table.Td>
                  <Table.Td>
                    <Text>{p.fornitore_nome || 'Galdieri'}</Text>
                  </Table.Td>
                  <Table.Td>
                    <Text fw={600}>{formatCurrency(p.prezzo_veicolo)}</Text>
                    <Group gap={4}>
                      {p.finanziamento_incassato ? 
                        <Badge size="xs" color="green" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'finanziamento_incassato', 'data_incasso_finanziamento')}>
                          Fin. ✓
                        </Badge> :
                        <Badge size="xs" color="yellow" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'finanziamento_incassato', 'data_incasso_finanziamento')}>
                          Fin. {formatCurrency(p.importo_finanziamento)}
                        </Badge>
                      }
                      {p.importo_acconto > 0 && (
                        p.acconto_incassato ? 
                          <Badge size="xs" color="green" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'acconto_incassato', 'data_incasso_acconto')}>
                            Acc. ✓
                          </Badge> :
                          <Badge size="xs" color="yellow" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'acconto_incassato', 'data_incasso_acconto')}>
                            Acc. {formatCurrency(p.importo_acconto)}
                          </Badge>
                      )}
                    </Group>
                  </Table.Td>
                  <Table.Td>
                    {p.commissione_compass > 0 ? (
                      <>
                        <Text>{formatCurrency(p.commissione_compass)}</Text>
                        {p.finanziaria === 'Compass' && (
                          <Text size="xs" c="dimmed">Netto: {formatCurrency(p.commissione_compass * 0.885)}</Text>
                        )}
                        {p.commissione_incassata ?
                          <Badge size="xs" color="green" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'commissione_incassata', 'data_incasso_commissione')}>
                            <IconCheck size={10} /> Incassata
                          </Badge> :
                          <Badge size="xs" color="yellow" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'commissione_incassata', 'data_incasso_commissione')}>
                            Da incassare
                          </Badge>
                        }
                      </>
                    ) : (
                      <Text c="dimmed">-</Text>
                    )}
                  </Table.Td>
                  <Table.Td>
                    {p.costo_pratica_passaggio > 0 ? (
                      <>
                        <Text>{formatCurrency(p.costo_pratica_passaggio)}</Text>
                        {p.incassato_pratica_passaggio ? 
                          <Badge size="xs" color="green" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'incassato_pratica_passaggio', 'data_incasso_pratica_passaggio')}>
                            <IconCheck size={10} /> Incassato
                          </Badge> :
                          <Badge size="xs" color="yellow" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'incassato_pratica_passaggio', 'data_incasso_pratica_passaggio')}>
                            Da incassare
                          </Badge>
                        }
                      </>
                    ) : (
                      <Text c="dimmed">-</Text>
                    )}
                  </Table.Td>
                  <Table.Td>
                    <Text>{formatCurrency(p.costo_acquisto_veicolo)}</Text>
                    {p.pagato_fornitore ? 
                      <Badge size="xs" color="green" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'pagato_fornitore', 'data_pagamento_fornitore')}>
                        <IconCheck size={10} /> Pagato
                      </Badge> :
                      <Badge size="xs" color="red" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'pagato_fornitore', 'data_pagamento_fornitore')}>
                        Da pagare
                      </Badge>
                    }
                    {p.data_scadenza_pagamento && !p.pagato_fornitore && (
                      <Text size="xs" c="dimmed">Scad: {new Date(p.data_scadenza_pagamento).toLocaleDateString('it-IT')}</Text>
                    )}
                  </Table.Td>
                  <Table.Td>
                    {p.spese_aci > 0 ? (
                      <>
                        <Text>{formatCurrency(p.spese_aci)}</Text>
                        {p.pagate_aci ?
                          <Badge size="xs" color="green" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'pagate_aci', 'data_pagamento_aci')}>
                            <IconCheck size={10} /> Pagata
                          </Badge> :
                          <Badge size="xs" color="red" variant="light" style={{ cursor: 'pointer' }} onClick={() => handleToggle(p, 'pagate_aci', 'data_pagamento_aci')}>
                            Da pagare
                          </Badge>
                        }
                      </>
                    ) : (
                      <Text c="dimmed">-</Text>
                    )}
                  </Table.Td>
                  <Table.Td>
                    <Text fw={700} c={p.margine >= 0 ? 'green' : 'red'}>{formatCurrency(p.margine)}</Text>
                  </Table.Td>
                  <Table.Td>{getStatoBadge(p.stato, p)}</Table.Td>
                  <Table.Td>
                    <Group gap="xs">
                      <Tooltip label="Modifica">
                        <ActionIcon variant="light" color="blue" onClick={() => handleEdit(p)}>
                          <IconPencil size={16} />
                        </ActionIcon>
                      </Tooltip>
                      <Tooltip label="Duplica">
                        <ActionIcon variant="light" color="teal" onClick={() => handleDuplicate(p)}>
                          <IconCopy size={16} />
                        </ActionIcon>
                      </Tooltip>
                      <Tooltip label="Elimina">
                        <ActionIcon variant="light" color="red" onClick={() => handleDelete(p)}>
                          <IconTrash size={16} />
                        </ActionIcon>
                      </Tooltip>
                    </Group>
                  </Table.Td>
                </Table.Tr>
              ))}
              {pratiche.length === 0 && (
                <Table.Tr>
                  <Table.Td colSpan={10}>
                    <Text ta="center" c="dimmed" py="xl">Nessuna pratica trovata</Text>
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </Card>

      {/* Modal */}
      <Modal
        opened={showModal}
        onClose={() => setShowModal(false)}
        title={editingPratica ? 'Modifica Pratica' : 'Nuova Pratica'}
        size="xl"
      >
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            {/* CLIENTE */}
            <Paper p="md" withBorder>
              <Text fw={600} mb="sm" c="teal">👤 Cliente</Text>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <TextInput label="Nome Cliente" required value={form.cliente_nome} onChange={(e) => setForm({...form, cliente_nome: e.target.value})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <TextInput label="Telefono" value={form.cliente_telefono} onChange={(e) => setForm({...form, cliente_telefono: e.target.value})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <TextInput label="Email" value={form.cliente_email} onChange={(e) => setForm({...form, cliente_email: e.target.value})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <TextInput label="Codice Fiscale" value={form.cliente_codice_fiscale} onChange={(e) => setForm({...form, cliente_codice_fiscale: e.target.value.toUpperCase()})} maxLength={16} style={{ textTransform: 'uppercase' }} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 8 }}>
                  <TextInput label="Indirizzo" value={form.cliente_indirizzo} onChange={(e) => setForm({...form, cliente_indirizzo: e.target.value})} placeholder="Via, Civico, CAP, Città (Prov.)" />
                </Grid.Col>
              </Grid>
            </Paper>

            {/* FORNITORE */}
            <Paper p="md" withBorder>
              <Text fw={600} mb="sm" c="teal">🏭 Fornitore Veicolo</Text>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 6 }}>
                  <TextInput label="Nome Fornitore" value={form.fornitore_nome} onChange={(e) => setForm({...form, fornitore_nome: e.target.value})} placeholder="Es: Galdieri, Privato, Concessionaria XYZ" />
                </Grid.Col>
              </Grid>
            </Paper>

            {/* VEICOLO */}
            <Paper p="md" withBorder>
              <Text fw={600} mb="sm" c="teal">🚗 Veicolo</Text>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <TextInput label="Marca" required value={form.marca} onChange={(e) => setForm({...form, marca: e.target.value})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <TextInput label="Modello" required value={form.modello} onChange={(e) => setForm({...form, modello: e.target.value})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <TextInput label="Targa" value={form.targa} onChange={(e) => setForm({...form, targa: e.target.value})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <TextInput label="Telaio" value={form.telaio} onChange={(e) => setForm({...form, telaio: e.target.value})} />
                </Grid.Col>
              </Grid>
            </Paper>

            {/* PREZZO VEICOLO (dal cliente) */}
            <Paper p="md" withBorder>
              <Text fw={600} mb="sm" c="teal">💰 Prezzo Veicolo (incassi dal cliente)</Text>
              <Text size="sm" c="dimmed" mb="md">Finanziamento + Acconto = Prezzo totale pagato dal cliente per l'auto</Text>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <Select label="Finanziaria" data={['Compass', 'Fiditalia', 'Nessuna']} value={form.finanziaria} onChange={(val) => setForm({...form, finanziaria: val})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <NumberInput label="Importo Finanziamento" decimalScale={2} prefix="€ " thousandSeparator="." decimalSeparator="," value={form.importo_finanziamento} onChange={(val) => setForm({...form, importo_finanziamento: val})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <NumberInput label="Acconto Cliente" decimalScale={2} prefix="€ " thousandSeparator="." decimalSeparator="," value={form.importo_acconto} onChange={(val) => setForm({...form, importo_acconto: val})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <NumberInput label="Commissione" decimalScale={2} prefix="€ " thousandSeparator="." decimalSeparator="," value={form.commissione_compass} onChange={(val) => setForm({...form, commissione_compass: val})} />
                </Grid.Col>
              </Grid>
            </Paper>

            {/* PRATICA PASSAGGIO PROPRIETÀ (dal cliente) */}
            <Paper p="md" withBorder>
              <Text fw={600} mb="sm" c="teal">📄 Pratica Passaggio Proprietà (incasso dal cliente)</Text>
              <Text size="sm" c="dimmed" mb="md">Somma corrisposta dal cliente per le spese di passaggio proprietà</Text>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <NumberInput label="Importo Pratica Passaggio" decimalScale={2} prefix="€ " thousandSeparator="." decimalSeparator="," value={form.costo_pratica_passaggio} onChange={(val) => setForm({...form, costo_pratica_passaggio: val})} />
                </Grid.Col>
              </Grid>
            </Paper>

            {/* COSTI (uscite) */}
            <Paper p="md" withBorder>
              <Text fw={600} mb="sm" c="red">📤 Costi (uscite)</Text>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <NumberInput label="Costo Acquisto Veicolo" decimalScale={2} prefix="€ " thousandSeparator="." decimalSeparator="," value={form.costo_acquisto_veicolo} onChange={(val) => setForm({...form, costo_acquisto_veicolo: val})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <DateInput label="Scadenza Pagamento" locale="it" valueFormat="DD/MM/YYYY" value={form.data_scadenza_pagamento} onChange={(val) => setForm({...form, data_scadenza_pagamento: val})} clearable />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <NumberInput label="Spese ACI Effettive" decimalScale={2} prefix="€ " thousandSeparator="." decimalSeparator="," value={form.spese_aci} onChange={(val) => setForm({...form, spese_aci: val})} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                  <NumberInput label="Altri Costi" decimalScale={2} prefix="€ " thousandSeparator="." decimalSeparator="," value={form.costi_manutenzione} onChange={(val) => setForm({...form, costi_manutenzione: val})} />
                </Grid.Col>
              </Grid>
            </Paper>

            {/* STATO */}
            <Paper p="md" withBorder>
              <Text fw={600} mb="sm" c="teal">📋 Stato Pratica</Text>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <Select label="Stato" data={[
                    { value: 'richiesta', label: 'Richiesta' },
                    { value: 'approvata', label: 'Approvata' },
                    { value: 'incassata', label: 'Incassata' },
                    { value: 'saldata', label: 'Saldata' },
                    { value: 'chiusa', label: 'Chiusa' },
                    { value: 'annullata', label: 'Annullata' },
                  ]} value={form.stato} onChange={(val) => setForm({...form, stato: val})} />
                </Grid.Col>
              </Grid>

              {editingPratica && (
                <Grid mt="md">
                  <Grid.Col span={{ base: 6, sm: 4, md: 2 }}>
                    <Checkbox label="Fin. incassato" checked={form.finanziamento_incassato} onChange={(e) => setForm({...form, finanziamento_incassato: e.target.checked})} />
                  </Grid.Col>
                  <Grid.Col span={{ base: 6, sm: 4, md: 2 }}>
                    <Checkbox label="Acc. incassato" checked={form.acconto_incassato} onChange={(e) => setForm({...form, acconto_incassato: e.target.checked})} />
                  </Grid.Col>
                  <Grid.Col span={{ base: 6, sm: 4, md: 2 }}>
                    <Checkbox label="Comm. incassata" checked={form.commissione_incassata} onChange={(e) => setForm({...form, commissione_incassata: e.target.checked})} />
                  </Grid.Col>
                  <Grid.Col span={{ base: 6, sm: 4, md: 2 }}>
                    <Checkbox label="Pass. incassato" checked={form.incassato_pratica_passaggio} onChange={(e) => setForm({...form, incassato_pratica_passaggio: e.target.checked})} />
                  </Grid.Col>
                  <Grid.Col span={{ base: 6, sm: 4, md: 2 }}>
                    <Checkbox label="Forn. pagato" checked={form.pagato_fornitore} onChange={(e) => setForm({...form, pagato_fornitore: e.target.checked})} />
                  </Grid.Col>
                  <Grid.Col span={{ base: 6, sm: 4, md: 2 }}>
                    <Checkbox label="ACI pagate" checked={form.pagate_aci} onChange={(e) => setForm({...form, pagate_aci: e.target.checked})} />
                  </Grid.Col>
                </Grid>
              )}
            </Paper>

            {/* NOTE */}
            <TextInput label="Note Altri Costi" value={form.note_manutenzione} onChange={(e) => setForm({...form, note_manutenzione: e.target.value})} placeholder="Es: manutenzione, provvigioni vendita, ecc." />
            <Textarea label="Note Generali" rows={2} value={form.note} onChange={(e) => setForm({...form, note: e.target.value})} />

            {/* DOCUMENTI - solo in modifica */}
            {editingPratica && (
              <Paper p="md" withBorder>
                <Text fw={600} mb="sm" c="teal">Documenti</Text>
                <Stack gap="xs">
                  {[
                    { key: 'libretto_originario', label: 'Libretto Originario' },
                    { key: 'mini_passaggio', label: 'Mini Passaggio' },
                    { key: 'documento_identita', label: 'Documento Identità' },
                    { key: 'atto_vendita', label: 'Atto di Vendita' },
                    { key: 'libretto_provvisorio', label: 'Libretto Provvisorio' },
                    { key: 'libretto_definitivo', label: 'Libretto Definitivo' },
                  ].map(doc => {
                    const fieldName = `doc_${doc.key}`;
                    const hasDoc = !!editingPratica[fieldName];
                    return (
                      <Group key={doc.key} justify="space-between" p="xs" style={{ backgroundColor: hasDoc ? '#f0fdf4' : '#fafafa', borderRadius: 6 }}>
                        <Group gap="xs">
                          <IconFile size={16} color={hasDoc ? 'green' : 'gray'} />
                          <Text size="sm" fw={500}>{doc.label}</Text>
                          {hasDoc && <Text size="xs" c="dimmed">({editingPratica[fieldName]})</Text>}
                        </Group>
                        <Group gap="xs">
                          {hasDoc && (
                            <>
                              <Tooltip label="Scarica">
                                <ActionIcon variant="light" color="blue" onClick={async () => {
                                  try {
                                    const res = await api.get(`/pratiche-auto/${editingPratica.id}/documenti/${doc.key}`, { responseType: 'blob' });
                                    const url = window.URL.createObjectURL(res.data);
                                    const a = document.createElement('a');
                                    a.href = url;
                                    a.download = editingPratica[fieldName] || `${doc.key}.pdf`;
                                    document.body.appendChild(a);
                                    a.click();
                                    window.URL.revokeObjectURL(url);
                                    a.remove();
                                  } catch (err) {
                                    notifications.show({ title: 'Errore', message: 'Errore download', color: 'red' });
                                  }
                                }}>
                                  <IconDownload size={16} />
                                </ActionIcon>
                              </Tooltip>
                              <Tooltip label="Elimina">
                                <ActionIcon variant="light" color="red" onClick={async () => {
                                  if (window.confirm(`Eliminare ${doc.label}?`)) {
                                    try {
                                      await api.delete(`/pratiche-auto/${editingPratica.id}/documenti/${doc.key}`);
                                      editingPratica[fieldName] = null;
                                      notifications.show({ title: 'Successo', message: 'Documento eliminato', color: 'green' });
                                      loadPratiche();
                                      // Aggiorna editingPratica
                                      const updated = { ...editingPratica, [fieldName]: null };
                                      setEditingPratica(updated);
                                    } catch (err) {
                                      notifications.show({ title: 'Errore', message: 'Errore eliminazione', color: 'red' });
                                    }
                                  }
                                }}>
                                  <IconX size={16} />
                                </ActionIcon>
                              </Tooltip>
                            </>
                          )}
                          <FileButton accept="application/pdf,image/*" onChange={async (file) => {
                            if (!file) return;
                            const formData = new FormData();
                            formData.append('file', file);
                            try {
                              const uploadRes = await api.post(`/pratiche-auto/${editingPratica.id}/documenti/${doc.key}`, formData, {
                                headers: { 'Content-Type': 'multipart/form-data' }
                              });
                              const savedFilename = uploadRes.data.filename || file.name;
                              notifications.show({ title: 'Successo', message: `${doc.label} caricato`, color: 'green' });
                              loadPratiche();
                              const updated = { ...editingPratica, [fieldName]: savedFilename };
                              setEditingPratica(updated);
                            } catch (err) {
                              notifications.show({ title: 'Errore', message: 'Errore caricamento', color: 'red' });
                            }
                          }}>
                            {(props) => (
                              <Tooltip label={hasDoc ? 'Sostituisci' : 'Carica'}>
                                <ActionIcon variant="light" color="teal" {...props}>
                                  <IconUpload size={16} />
                                </ActionIcon>
                              </Tooltip>
                            )}
                          </FileButton>
                        </Group>
                      </Group>
                    );
                  })}
                </Stack>

                {/* Bottone Invia Email Passaggio */}
                <Button
                  mt="md"
                  fullWidth
                  variant="light"
                  color="blue"
                  leftSection={<IconMail size={18} />}
                  loading={false}
                  onClick={async (e) => {
                    const btn = e.currentTarget;
                    btn.disabled = true;
                    try {
                      const res = await api.post(`/pratiche-auto/${editingPratica.id}/invia-email`);
                      notifications.show({
                        title: 'Email inviata',
                        message: res.data.message,
                        color: 'green'
                      });
                    } catch (err) {
                      const detail = err.response?.data?.detail || 'Errore invio email';
                      notifications.show({
                        title: 'Errore',
                        message: detail,
                        color: 'red',
                        autoClose: 8000
                      });
                    } finally {
                      btn.disabled = false;
                    }
                  }}
                >
                  Invia Email Passaggio
                </Button>
              </Paper>
            )}

            <Group justify="flex-end" mt="md">
              <Button variant="light" onClick={() => setShowModal(false)}>Annulla</Button>
              <Button type="submit">Salva</Button>
            </Group>
          </Stack>
        </form>
      </Modal>
    </Stack>
  );
}

export default PraticheAuto;
